import './ImportFromFile.scss';

import { useContext, useEffect } from 'react';
import { match, useLocation, useRouteMatch } from 'react-router';

import { HelpPanelTopicOptions } from '../../common/Constants';
import { MatchParam } from '../../common/types';
import { HelpPanelContext } from '../../contexts/HelpPanelContext';
import ImportPage from './import/ImportPage';

interface LocationState {
    fromType: string;
}

function ImportFromFile() {
    const match: match<MatchParam> | null = useRouteMatch({
        path: '/portfolio/:portfolioId',
        
    });
    const { state } = useLocation();
    const { panelHandler } = useContext(HelpPanelContext);
    useEffect(() => {
        panelHandler(HelpPanelTopicOptions.IMPORT_FROM_FILE);
    }, [ panelHandler ]);

    const portfolioId = match?.params?.portfolioId;
    if (!portfolioId) {
        return null;
    }
    const initType = (state as LocationState)?.fromType || '';

    return (
        <ImportPage
            initType={initType}
            portfolioId={portfolioId}
        ></ImportPage>
    );
}

export default ImportFromFile;
